import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import * as Yup from "yup";
import { Container } from '../../base/Container';
import AppToaster from '../../commonLib/AppToaster';
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import * as applicationUserCrud from '../../_crud/applicationUserCrud';
import { LoadingButton } from './../../commonLib/LoadingButton'



export function ResetPassword() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const history = useHistory();
    const { id } = useParams()

    const initialValues = {
        userName: id,
        newPass: "",
        confirmPassword: "",
    }

    const Schema = Yup.object().shape({
        newPass: Yup.string()
            .required('Please Enter your new password')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Character"
            ),
        confirmPassword: Yup.string()
            .required('Please Enter your confirm password')
            .oneOf([Yup.ref("newPass"), null], "Passwords must match"),
    })

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values) => {
            Save(values);
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });

    const Save = (value) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true)
        applicationUserCrud.ResetPassword(value)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster('Reset successfully.', 'success')
                    history.goBack()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    return (
        <Container title="Reset Password" isBack="true" isContact="true">
            <form onSubmit={formik.handleSubmit} class="form-horizontal">
                <div class="form-group">
                    <label class="col-md-3 control-label no-padding-right">New Password</label>
                    <div class="col-md-5">
                        <input className="form-control" type="password" placeholder="New Password" name="newPass" {...formik.getFieldProps("newPass")} />
                        {
                            formik.touched.newPass &&
                                formik.errors.newPass ? (
                                <label className="text-danger" >
                                    {formik.errors.newPass}
                                </label>
                            ) : null
                        }
                    </div>
                </div>

                <div class="form-group">
                    <label class=" col-md-3 control-label no-padding-right">Confirm Password</label>
                    <div class="col-md-5">
                        <input className="form-control" type="password" placeholder="Confirm Password" name="confirmPassword" {...formik.getFieldProps("confirmPassword")} />
                        {
                            formik.touched.confirmPassword &&
                                formik.errors.confirmPassword ? (
                                <label className="text-danger" >
                                    {formik.errors.confirmPassword}
                                </label>
                            ) : null
                        }
                    </div>
                </div>

                <div class="clearfix form-actions">
                    <div class="pull-right">
                        {isLoadingLocal ?
                            <LoadingButton />
                            :
                            <button class="btn btn-info" type="submit" expand="block" disabled={!formik.isValid}>
                                <i class="ace-icon fa fa-check bigger-110"></i>
                                Reset
                            </button>}
                    </div>
                </div>

            </form>
        </Container >
    )
}

